import { environment } from '@env/environment';

export function logMsg(klass, msg): void {
  if (environment.debugMode) {
    console.log(`[${klass.name}] ${msg}`);
  }
}
